import React from "react";
import { Building2, Landmark, Banknote, Wallet, PiggyBank, ShieldCheck } from "lucide-react";

const partners = [
  { name: "Banco Alpha", icon: Landmark },
  { name: "Crédito Sur", icon: Building2 },
  { name: "Financiera Andes", icon: Banknote },
  { name: "CapitalPlus", icon: Wallet },
  { name: "Ahorro Cordillera", icon: PiggyBank },
  { name: "Seguro Pacífico", icon: ShieldCheck },
];

export default function PartnerEntities() {
  return (
    <section
      className="py-16 lg:py-20 bg-white border-y border-slate-200"
      data-testid="partner-entities-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-sm uppercase tracking-[0.2em] font-bold text-blue-600">
            Entidades aliadas
          </span>
          <h2 className="mt-3 text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">
            Trabajamos con distintas instituciones financieras
          </h2>
          <p className="mt-3 text-sm text-slate-500">
            Logos y nombres representativos. La disponibilidad de entidades
            puede variar en el tiempo.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {partners.map((p, i) => (
            <div
              key={i}
              className="flex items-center justify-center gap-2 rounded-xl border border-slate-200 bg-slate-50 py-5 px-3 opacity-70 hover:opacity-100 hover:border-slate-300 transition-all"
              data-testid={`partner-${i}`}
            >
              <p.icon className="h-5 w-5 text-slate-600" strokeWidth={1.5} />
              <span className="text-sm font-semibold text-slate-700 tracking-tight">
                {p.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
